// extracted by mini-css-extract-plugin
export var arrows = "_6w-5";
export var decrementer = "_6w-9";
export var disabled = "_6w-3";
export var error = "_6w-1";
export var hiddenText = "_6w-a";
export var incrementer = "_6w-8";
export var input = "_6w-7";
export var inputWrapper = "_6w-0";
export var leadingIcon = "_6w-b";
export var readonly = "_6w-2";
export var regular = "_6w-6";
export var small = "_6w-4";